import axios, { AxiosResponse } from "axios"
import { GeocodeMetadata } from "../models/api/GeocodeMetadata"
import { NomGeocodeResp } from "../models/api/NomGeocodeResp"
import { GeocodeService } from "./interfaces/GeocodeService"

const baseUrl = 'https://nominatim.openstreetmap.org'
const api = axios.create({baseURL: baseUrl})

class NomGeocoderService extends GeocodeService {


    async geocodeFromCoord(lat: number, long: number): Promise<GeocodeMetadata> {

        let geocodeData: GeocodeMetadata
        
        try {

            const resp = await this.geocode(lat, long)
            let data = resp.data
            console.log(data)
            geocodeData = {
                country: data.address.country,
                countryCode: data.address.country_code,
                region: data.address.state_district,
                state: data.address.state,
                city: data.address.city
            }

            return geocodeData
            
        } catch (error) {
            console.error(error)
            throw error
        }
    }

    private geocode(lat: number, long: number){

        return api.get<NomGeocodeResp>('/reverse?format=jsonv2', {
            params: {
                format: 'jsonv2',
                lat: lat,
                lon: long
            }
        })
    }


}

export default new NomGeocoderService()